// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.panel-title[data-v-479e6787] {\n    margin-left: 7px;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n.info-tv-text[data-v-479e6787] {\n    margin-left: 7px;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\ntable[data-v-479e6787] {\n    margin-bottom: 0;\n}\n.panel-info[data-v-479e6787] {\n    margin-top: 10px;\n}\n.table-td[data-v-479e6787] {\n    width: 30%;\n}\n", ""]);
// Exports
module.exports = exports;
